import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface SystemLockStatusResponse {
  callSuccess: string;
  jsonObject?: Array<{ SYSTEMLOCK?: string }>;
  errorMessage?: string;
}

export interface SaveLockResponse {
  callSuccess: string;
  errorMessage?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ShutdownDstAppService {
  constructor(private http: HttpClient) {}

  /**
   * Get DST system lock/unlock status.
   * URL: baseUrl/loadJsonObject?action_id=32639
   */
  getSystemLockUnlockStatus(baseUrl: string): Observable<SystemLockStatusResponse> {
    const url = `${baseUrl}/loadJsonObject?action_id=32639`;
    return this.http.get<SystemLockStatusResponse>(url, { withCredentials: true });
  }

  /**
   * Save system lock/unlock state.
   * URL structure: /saveJsonObject?action_id=32640 (appended to baseUrl).
   * Payload: isActive, tax_year, scenario, jcd_key (application/x-www-form-urlencoded).
   */
  saveSystemLockUnlock(
    baseUrl: string,
    isActive: string,
    globalService: any,
    filterParams: any
  ): Observable<SaveLockResponse> {
    const g = globalService ?? {};
    const f = filterParams ?? {};
    const tax_year = f.tax_year ?? g.tax_year ?? '';
    const scenario = f.scenario ?? g.scenario ?? '';
    const jcd_key = f.jcd_key ?? g.jcd_key ?? '';

    const base = (baseUrl || '').replace(/\/$/, '');
    const url = `${base}/saveJsonObject?action_id=32640`;
    const urlEncoded = new URLSearchParams();
    urlEncoded.set('isActive', String(isActive));
    urlEncoded.set('tax_year', String(tax_year));
    urlEncoded.set('scenario', String(scenario));
    urlEncoded.set('jcd_key', String(jcd_key));

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post<SaveLockResponse>(url, urlEncoded.toString(), {
      headers,
      withCredentials: true,
    });
  }
}
